import { useState } from "react";

const products = [
  {
    id: "delta-2",
    name: "DELTA 2",
    tagline: "The everyday home backup powerhouse",
    capacity: "1024Wh",
    output: "1800W AC",
    expandable: "Up to 2048Wh",
    weight: "27 lbs",
    charge: "0–80% in 50 min",
    cycles: "3,000+ cycles",
    ports: "15 outlets",
    price: "~$999",
    badge: "Best Seller",
    badgeColor: "bg-amber-500",
    image: "https://public.readdy.ai/ai/img_res/5c5e9a96c656a9a6cff17c3b88494392.jpg",
    highlights: [
      "Powers 90% of home appliances",
      "LFP battery — 10-year lifespan",
      "Expandable with DELTA 2 Extra Battery",
      "Smart app control via Wi-Fi & Bluetooth",
    ],
    useCases: ["Home backup", "Camping", "RV travel"],
  },
  {
    id: "delta-pro",
    name: "DELTA Pro",
    tagline: "Whole-home backup for serious outages",
    capacity: "3600Wh",
    output: "3600W AC",
    expandable: "Up to 25kWh",
    weight: "99 lbs",
    charge: "0–80% in 1.8 hrs",
    cycles: "3,500+ cycles",
    ports: "15 outlets",
    price: "~$3,499",
    badge: "Most Powerful",
    badgeColor: "bg-rose-500",
    image: "https://readdy.ai/api/search-image?query=EcoFlow%20DELTA%20Pro%20large%20portable%20power%20station%20premium%20product%20shot%20on%20dark%20background%2C%20dramatic%20studio%20lighting%2C%20glowing%20power%20display%2C%20high-end%20energy%20storage%20technology%2C%20cinematic%20quality%20photography&width=600&height=400&seq=ecoflow-deltapro-v1&orientation=landscape",
    highlights: [
      "Powers entire home during outages",
      "Expandable to 25kWh with Smart Extra Batteries",
      "EV charging station compatible",
      "Dual voltage 120V/240V output",
    ],
    useCases: ["Whole-home backup", "Off-grid living", "Job sites"],
  },
  {
    id: "river-2-pro",
    name: "RIVER 2 Pro",
    tagline: "Compact power for life on the move",
    capacity: "768Wh",
    output: "800W AC",
    expandable: "Up to 1536Wh",
    weight: "17.2 lbs",
    charge: "0–100% in 70 min",
    cycles: "3,000+ cycles",
    ports: "11 outlets",
    price: "~$599",
    badge: "Most Portable",
    badgeColor: "bg-emerald-500",
    image: "https://readdy.ai/api/search-image?query=EcoFlow%20RIVER%202%20Pro%20compact%20portable%20power%20station%20clean%20white%20background%2C%20professional%20product%20photography%2C%20lightweight%20portable%20energy%20device%2C%20modern%20minimalist%20design%2C%20sharp%20studio%20lighting&width=600&height=400&seq=ecoflow-river2pro-v1&orientation=landscape",
    highlights: [
      "Ultra-fast 70-min full charge",
      "Lightest in its class at 17.2 lbs",
      "Expandable with RIVER 2 Max Extra Battery",
      "X-Stream fast charging technology",
    ],
    useCases: ["Camping", "Van life", "Emergency kit"],
  },
  {
    id: "smart-home-panel",
    name: "Smart Home Panel 2",
    tagline: "Whole-home integration made simple",
    capacity: "N/A",
    output: "7200W",
    expandable: "10 circuits",
    weight: "22 lbs",
    charge: "Seamless grid switching",
    cycles: "N/A",
    ports: "10 home circuits",
    price: "~$1,699",
    badge: "New",
    badgeColor: "bg-sky-500",
    image: "https://readdy.ai/api/search-image?query=EcoFlow%20Smart%20Home%20Panel%202%20electrical%20panel%20smart%20home%20energy%20management%20system%2C%20clean%20white%20background%2C%20professional%20product%20photography%2C%20modern%20home%20technology%2C%20premium%20build%20quality%2C%20studio%20lighting&width=600&height=400&seq=ecoflow-shp2-v1&orientation=landscape",
    highlights: [
      "Controls up to 10 home circuits",
      "Seamless grid-to-battery switching",
      "Works with DELTA Pro & DELTA Pro Ultra",
      "Real-time energy monitoring via app",
    ],
    useCases: ["Whole-home backup", "Solar integration", "Smart home"],
  },
  {
    id: "delta-pro-ultra",
    name: "DELTA Pro Ultra",
    tagline: "The ultimate home energy system",
    capacity: "6144Wh",
    output: "7200W AC",
    expandable: "Up to 90kWh",
    weight: "154 lbs",
    charge: "0–80% in 1.5 hrs",
    cycles: "4,000+ cycles",
    ports: "20 outlets",
    price: "~$5,799",
    badge: "Flagship",
    badgeColor: "bg-violet-500",
    image: "https://readdy.ai/api/search-image?query=EcoFlow%20DELTA%20Pro%20Ultra%20large%20home%20energy%20storage%20system%20premium%20product%20photography%2C%20dark%20dramatic%20background%2C%20glowing%20power%20indicators%2C%20flagship%20energy%20technology%2C%20cinematic%20studio%20lighting%2C%20ultra%20high%20resolution&width=600&height=400&seq=ecoflow-dpu-v1&orientation=landscape",
    highlights: [
      "6144Wh base, expandable to 90kWh",
      "7200W output — powers entire home",
      "Built-in inverter, no extra hardware",
      "Stackable modular design",
    ],
    useCases: ["Whole-home backup", "Off-grid", "Solar storage"],
  },
  {
    id: "powerstream",
    name: "PowerStream",
    tagline: "Microinverter for balcony solar",
    capacity: "Pairs with DELTA",
    output: "600W / 800W",
    expandable: "Balcony solar ready",
    weight: "5.5 lbs",
    charge: "Plug-and-play solar",
    cycles: "N/A",
    ports: "2 solar inputs",
    price: "~$299",
    badge: "Solar",
    badgeColor: "bg-teal-500",
    image: "https://readdy.ai/api/search-image?query=EcoFlow%20PowerStream%20microinverter%20solar%20energy%20device%20compact%20white%20background%2C%20professional%20product%20photography%2C%20clean%20modern%20design%2C%20solar%20technology%2C%20minimalist%20studio%20lighting%2C%20sharp%20detail&width=600&height=400&seq=ecoflow-powerstream-v1&orientation=landscape",
    highlights: [
      "Plug-and-play balcony solar setup",
      "Pairs with any DELTA power station",
      "Reduces electricity bill immediately",
      "Smart energy routing via app",
    ],
    useCases: ["Apartment solar", "Balcony setup", "Energy savings"],
  },
];

export default function EcoFlowProducts() {
  const [activeProduct, setActiveProduct] = useState<string | null>(null);

  return (
    <section id="products" className="py-20 px-4 md:px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-14">
          <span className="inline-block text-amber-500 text-xs font-bold uppercase tracking-widest mb-3">Product Lineup</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 tracking-tight mb-4">
            The Full EcoFlow Lineup
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            From compact camping companions to whole-home backup systems — every product we&apos;ll carry once we go live.
          </p>
        </div>

        {/* Product grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map((product) => (
            <div
              key={product.id}
              className={`group relative bg-white border rounded-xl overflow-hidden transition-all duration-200 cursor-pointer ${
                activeProduct === product.id
                  ? "border-amber-400 ring-2 ring-amber-400/20"
                  : "border-gray-100 hover:border-amber-200"
              }`}
              onClick={() => setActiveProduct(activeProduct === product.id ? null : product.id)}
            >
              {/* Badge */}
              <div className="absolute top-3 left-3 z-10">
                <span className={`${product.badgeColor} text-white text-[10px] font-bold px-2.5 py-1 rounded-full`}>
                  {product.badge}
                </span>
              </div>

              {/* Coming soon overlay */}
              <div className="absolute top-3 right-3 z-10">
                <span className="bg-gray-900/80 text-gray-300 text-[10px] font-semibold px-2.5 py-1 rounded-full flex items-center gap-1">
                  <div className="w-2.5 h-2.5 flex items-center justify-center">
                    <i className="ri-time-line text-[10px]"></i>
                  </div>
                  Coming Soon
                </span>
              </div>

              {/* Product image */}
              <div className="w-full h-48 bg-gray-50 overflow-hidden">
                <img
                  src={product.image}
                  alt={`${product.name} portable power station — coming soon to Iron Haven Supply`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Card body */}
              <div className="p-5">
                <div className="mb-3">
                  <h3 className="text-gray-900 font-extrabold text-lg leading-tight">{product.name}</h3>
                  <p className="text-gray-500 text-xs mt-0.5">{product.tagline}</p>
                </div>

                {/* Key specs row */}
                <div className="grid grid-cols-3 gap-2 mb-4">
                  {[
                    { label: "Capacity", value: product.capacity },
                    { label: "Output", value: product.output },
                    { label: "Weight", value: product.weight },
                  ].map((spec) => (
                    <div key={spec.label} className="bg-gray-50 rounded-lg px-2.5 py-2 text-center">
                      <p className="text-gray-900 font-bold text-xs leading-tight">{spec.value}</p>
                      <p className="text-gray-400 text-[10px] mt-0.5">{spec.label}</p>
                    </div>
                  ))}
                </div>

                {/* Use cases */}
                <div className="flex flex-wrap gap-1.5 mb-4">
                  {product.useCases.map((uc) => (
                    <span key={uc} className="bg-amber-50 text-amber-700 text-[10px] font-semibold px-2 py-0.5 rounded-full">
                      {uc}
                    </span>
                  ))}
                </div>

                {/* Expand toggle */}
                <button className="flex items-center gap-1.5 text-xs font-semibold text-amber-600 hover:text-amber-500 transition-colors cursor-pointer whitespace-nowrap">
                  <span>{activeProduct === product.id ? "Hide details" : "View full specs"}</span>
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    {activeProduct === product.id
                    ? <i className="ri-arrow-up-s-line text-sm"></i>
                    : <i className="ri-arrow-down-s-line text-sm"></i>
                  }
                  </div>
                </button>

                {/* Expanded details */}
                {activeProduct === product.id && (
                  <div className="mt-4 pt-4 border-t border-gray-100">
                    <div className="grid grid-cols-2 gap-2 mb-4">
                      {[
                        { label: "Expandable", value: product.expandable },
                        { label: "Charge Speed", value: product.charge },
                        { label: "Battery Cycles", value: product.cycles },
                        { label: "Ports", value: product.ports },
                      ].map((spec) => (
                        <div key={spec.label} className="flex flex-col">
                          <span className="text-gray-400 text-[10px] font-medium">{spec.label}</span>
                          <span className="text-gray-800 text-xs font-semibold mt-0.5">{spec.value}</span>
                        </div>
                      ))}
                    </div>

                    <div className="space-y-1.5">
                      {product.highlights.map((h) => (
                        <div key={h} className="flex items-start gap-2">
                          <div className="w-3.5 h-3.5 flex items-center justify-center mt-0.5 shrink-0">
                            <i className="ri-check-line text-amber-500 text-xs"></i>
                          </div>
                          <span className="text-gray-600 text-xs leading-relaxed">{h}</span>
                        </div>
                      ))}
                    </div>

                    <div className="mt-4 flex items-center justify-between">
                      <div>
                        <span className="text-gray-400 text-[10px]">Est. retail price</span>
                        <p className="text-gray-900 font-extrabold text-base">{product.price}</p>
                      </div>
                      <a
                        href="#ecoflow-signup"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          document.getElementById("ecoflow-signup")?.scrollIntoView({ behavior: "smooth" });
                        }}
                        className="flex items-center gap-1.5 bg-amber-500 hover:bg-amber-400 text-white text-xs font-bold px-4 py-2 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                      >
                        <div className="w-3.5 h-3.5 flex items-center justify-center">
                          <i className="ri-bell-line text-xs"></i>
                        </div>
                        Notify Me
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Bottom note */}
        <p className="text-center text-gray-400 text-xs mt-8">
          Pricing shown is estimated MSRP. Authorized dealer pricing and launch promotions will be announced at launch.
        </p>
      </div>
    </section>
  );
}
